import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Creators as procedureActions } from '../../../../../../../domain/useCases/procedures/getProcedureInformation';
import { Creators as registerActions } from '../../../../../../../domain/useCases/procedures/RetirementOfPeriod/registerUseCase';
import { Creators as requestStatusActions } from '../../../../../../../domain/useCases/procedures/getStudentProcedureStatus';
import RetirementOfPeriodRegisterView from './RetirementPeriodRegisterView';
import routes from '@/presentation/components/Routes/routingMap';
import constants from '@/presentation/modules/procedures/constants';

const RetirementOfPeriodRegisterViewController: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const procedureSelectedInfo = useSelector(
    (state: any) => state.procedureInformation?.procedure
  );
  const { isLoading, requestId, error, isSuccess } = useSelector(
    (state: any) => state.registerRetirementOfPeriod
  );
  const periodId = useSelector(
    (state: any) => state.profile.data.academic.period.id
  ).toString();
  const { career } = useSelector((state: any) => state.profile.data.academic);

  useEffect(() => {
    if (!procedureSelectedInfo) {
      dispatch(
        procedureActions.getProcedureInformation(
          constants.categories.requests.procedures.removeOfPeriod
        )
      );
    }
  }, [dispatch, procedureSelectedInfo]);

  const [isQuit, setIsQuit] = useState(false);
  const [isFieldsFull, setIsFieldsFull] = useState(false);
  const [errorCRM, setErrorCRM] = useState(false);

  const handleProcessing = useCallback(
    (fieldsFormR: {
      reason: string;
      detail: string;
      contact: string;
      detail2: string;
      idDetail2: string;
    }) => {
      dispatch(
        registerActions.registerRetirementOfPeriod(
          procedureSelectedInfo?.procedureId ||
            constants.categories.requests.procedures.removeOfPeriod,
          fieldsFormR.reason,
          fieldsFormR.detail,
          fieldsFormR.contact,
          fieldsFormR.idDetail2,
          fieldsFormR.detail2,
          periodId,
          career
        )
      );
    },
    [dispatch, procedureSelectedInfo, periodId]
  );

  const handleClear = useCallback(() => {
    dispatch(registerActions.registerRetirementOfPeriodClear());
  }, [dispatch]);

  const handleBack = useCallback(() => {
    if (isFieldsFull) {
      setIsQuit(true);
    } else {
      history.push(
        routes.student.procedures.categories.requests.retirementperiod
          .procedureinfo
      );
    }
  }, [isFieldsFull, history]);

  const handleSubmit = useCallback(
    (fields: any) => {
      if (fields) {
        handleProcessing(fields);
      }
    },
    [handleProcessing]
  );

  const handleCloseModalRequestExist = useCallback(() => {
    handleClear();
  }, [handleClear]);

  const onFieldsReady = useCallback((ready: boolean) => {
    setIsFieldsFull(ready);
  }, []);

  const handleGoToExists = useCallback(() => {
    dispatch(
      requestStatusActions.getStudentProcedureStatus(
        procedureSelectedInfo?.procedureId ||
          constants.categories.requests.procedures.removeOfPeriod,
        requestId
      )
    );
    history.push(
      routes.student.procedures.categories.requests.retirementperiod
        .procedureprogress
    );
  }, [dispatch, procedureSelectedInfo, requestId, history]);

  useEffect(() => {
    if (requestId && isSuccess && isFieldsFull) {
      dispatch(
        requestStatusActions.getStudentProcedureStatus(
          constants.categories.requests.procedures.removeOfPeriod,
          requestId
        )
      );
      history.push(routes.student.procedures.home);
    }
  }, [dispatch, history, isSuccess, isFieldsFull, requestId]);

  useEffect(() => {
    if (error?.trim()) {
      setErrorCRM(true);
    }
  }, [requestId, error]);

  const handleCloseModalConfirmation = useCallback(() => {
    setIsQuit(false);
  }, []);

  const handleQuitModalConfirmation = useCallback(() => {
    handleClear();
    history.push(
      routes.student.procedures.categories.requests.retirementperiod
        .procedureinfo
    );
  }, [handleClear, history]);

  const goBackToProcedures = useCallback(() => {
    handleClear();
    history.push(routes.student.procedures.home);
  }, []);

  return (
    <RetirementOfPeriodRegisterView
      procedureSelectedInfo={procedureSelectedInfo}
      isLoading={isLoading}
      handleSubmit={handleSubmit}
      handleBack={handleBack}
      onFieldsReady={onFieldsReady}
      handleCloseModalConfirmation={handleCloseModalConfirmation}
      handleCloseModalRequestExist={handleCloseModalRequestExist}
      handleGoToExists={handleGoToExists}
      handleQuitModalConfirmation={handleQuitModalConfirmation}
      showModalRequestExist={!!error && !!requestId}
      showModalConfirmation={isQuit}
      errorCRM={errorCRM}
      setErrorCRM={setErrorCRM}
      error={error}
      goBackToProcedures={goBackToProcedures}
    />
  );
};

export default RetirementOfPeriodRegisterViewController;
